'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import useInterval from '../hooks/useInterval';
const animationDelay = 500;
export default (() => {
  const [dots, setDots] = useState('');

  const addDot = () => {
    let newDots = `${dots}.`;

    if (newDots.length > 3) {
      newDots = '';
    }

    setDots(newDots);
  };

  useInterval(addDot, animationDelay);
  return /*#__PURE__*/_jsx("span", {
    className: "loading-dots",
    children: dots
  });
});